import React, { Component } from "react";
import "../../../../Common/Common.css";
import "./ContactUs.css";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import UserInquiry from "../../../UserInquiry/UserInquiry";
import UserInquiryForm from "../../../UserInquiryForm/UserInquiryForm";
import { toast, ToastContainer } from "react-toastify";
import { css } from "glamor";
import InitialQuotationState from "../../../QuotationForm/InitialQuotationState";
import {BASE_URL} from "../../../../../configuration";

class ContactUs extends Component {

    constructor(props) {
        super(props);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false
        };
    }

    handleClose = () => {

        this.setState({ show: false }, ()=>{
            if(window.location.href === BASE_URL+'inquiry'){
                window.location.replace(BASE_URL);
            }
        });
    };

    handleShow = () => {
        if (localStorage.getItem("logStatus") !== null) {
//            this.setState({ show: true });
            window.location.href = "https://kitcutlabo.com/contact-form/";
            InitialQuotationState.fromFlow = false;
            window.scrollTo(0, 0);
        }
        else {
            window.location.href = "https://kitcutlabo.com/contact-form/";
        }
    };

    render() {
        return (
            <div className={this.props.quo === true ? 'quo-contact' : "dropdown-nav"}>
                {
                    this.props.quo === true ? <span className="quo-contact-us" onClick={this.handleShow}>お問い合わせフォームよりご連絡下さい。</span> :
                        <span className="sub-title-span" id="sub-title-span-resp" onClick={this.handleShow}>
                            <FormattedMessage id="app.navigation.contact"
                                defaultMessage="Contact"
                                description="" />
                        </span>
                        
                }

                <ToastContainer position={toast.POSITION.TOP_CENTER} hideProgressBar={true} />
                <Modal dialogClassName="contact-modal" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.navigation.contact"
                                defaultMessage="Contact"
                                description="" />
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="contact-form-text">
                            <UserInquiryForm userId={this.props.userId} handle={this.handleClose} />
                        </div>

                    </Modal.Body>

                </Modal>
            </div>
        );
    }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/ContactUs/ContactUs.js